import { Button } from "@/components/ui";
import { useDashboardClaimActionMutation } from "@/lib/data/react-query/matters/dashboard-tables";
import type { DashboardActionCell } from "@/lib/types/MatterDashboardTable";
import { isAxiosError } from "axios";
import toast from "react-hot-toast";

function claimError(error: unknown) {
  if (isAxiosError(error) && error.response?.status === 409)
    return "This action is no longer available to claim.";
  if (isAxiosError(error) && error.response?.status === 403)
    return "You no longer have permission to claim this action.";
  if (isAxiosError(error) && error.response?.status === 404)
    return "This action could not be found.";
  return "Unable to claim this action. Please try again.";
}

export function DashboardClaimActionButton({
  action,
  matterId,
  userId,
  firmId,
  onClaimed,
  compact = false,
}: {
  action: DashboardActionCell;
  matterId: string;
  userId: string;
  firmId: string;
  onClaimed?: (phaseActionId: string) => void;
  compact?: boolean;
}) {
  const claim = useDashboardClaimActionMutation(firmId, userId);

  const submit = async () => {
    if (claim.isPending) return;
    try {
      await claim.mutateAsync({
        phaseActionId: action.phaseActionId,
        body: { userId, matterId, title: action.title },
      });
      onClaimed?.(action.phaseActionId);
      toast.success("Task claimed");
    } catch (failure) {
      toast.error(claimError(failure));
    }
  };

  return (
    <Button
      variant="outline"
      size="xs"
      className={
        compact ? "hover:bg-muted/60 h-6 rounded-md px-2 text-xs" : undefined
      }
      disabled={claim.isPending}
      onClick={() => void submit()}
    >
      Claim
    </Button>
  );
}
